import * as Yup from 'yup';

export default Yup.object().shape({
  email: Yup.string()
    .email('Email address is not valid')
    .required('Please provide an email address')
});
